export enum Components {
  components = 'components',
  moonshop = 'moonshop',
  homeCatalog = 'homeCatalog',
  productDetail = 'productDetail',
  categoryProductList = 'categoryProductList',
  alerts = 'alerts'
}
